import { render } from "./other-deals-popup.vue?vue&type=template&id=657963e2&scoped=true&ts=true"
import script from "./other-deals-popup.vue?vue&type=script&lang=ts"
export * from "./other-deals-popup.vue?vue&type=script&lang=ts"

import "./other-deals-popup.css?vue&type=style&index=0&id=657963e2&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657963e2"]])

export default __exports__